/**
 * <zh/> 内置色板
 *
 * <en/> Built-in palettes
 */
export const spectral = [
    'rgb(158, 1, 66)',
    'rgb(213, 62, 79)',
    'rgb(244, 109, 67)',
    'rgb(253, 174, 97)',
    'rgb(254, 224, 139)',
    'rgb(255, 255, 191)',
    'rgb(230, 245, 152)',
    'rgb(171, 221, 164)',
    'rgb(102, 194, 165)',
    'rgb(50, 136, 189)',
    'rgb(94, 79, 162)',
];
export const tableau = [
    'rgb(78, 121, 167)',
    'rgb(242, 142, 44)',
    'rgb(225, 87, 89)',
    'rgb(118, 183, 178)',
    'rgb(89, 161, 79)',
    'rgb(237, 201, 73)',
    'rgb(175, 122, 161)',
    'rgb(255, 157, 167)',
    'rgb(156, 117, 95)',
    'rgb(186, 176, 171)',
];
export const oranges = [
    'rgb(255, 245, 235)',
    'rgb(254, 230, 206)',
    'rgb(253, 208, 162)',
    'rgb(253, 174, 107)',
    'rgb(253, 141, 60)',
    'rgb(241, 105, 19)',
    'rgb(217, 72, 1)',
    'rgb(166, 54, 3)',
    'rgb(127, 39, 4)',
];
export const greens = [
    'rgb(247, 252, 245)',
    'rgb(229, 245, 224)',
    'rgb(199, 233, 192)',
    'rgb(161, 217, 155)',
    'rgb(116, 196, 118)',
    'rgb(65, 171, 93)',
    'rgb(35, 139, 69)',
    'rgb(0, 109, 44)',
    'rgb(0, 68, 27)',
];
export const blues = [
    'rgb(247, 251, 255)',
    'rgb(222, 235, 247)',
    'rgb(198, 219, 239)',
    'rgb(158, 202, 225)',
    'rgb(107, 174, 214)',
    'rgb(66, 146, 198)',
    'rgb(33, 113, 181)',
    'rgb(8, 81, 156)',
    'rgb(8, 48, 107)',
];
//# sourceMappingURL=index.js.map